<template functional>
  <span class="next-number" :data-level="props.level" :data-value="props.value" :data-type="props.type" />
</template>
<script>
export default {
  name: 'w-next-number'
};
</script>

<style>
.next-number {
  display: inline-block;
  min-width: 1.5rem;
  margin-right: 0.3rem !important;
}
.next-number[data-level='1'] {
  margin-left: 1.8rem;
}
.next-number[data-level='2'] {
  margin-left: 3.6rem;
}
.next-number[data-level='3'] {
  margin-left: 5.4rem;
}
.next-number[data-level='4'] {
  margin-left: 7.2rem;
}
</style>
